<template>
    <div class="company-article">
        <dl id="dl_en" class="hide">
        <dd>Arivo is a classic word for arrival, it means "Wherever you go, our tyres will take you to your destination." The design and originality of brand Arivo are from the United Kingdom. </dd>
        <dd>ARIVO TYRE is manufactured for Passenger, SUV, Light Truck and Commercial vehicles with its own unique product range which expands rapidly through European advanced technology in design and production, All tyres have strict quality control and have obtained ISO9001&ISO/16949 Quality Management System Certification. Product Liability is underwritten by Jordan & Jordan Insurance Group (USA).</dd>
        <dd>We are committed to providing quality tyres and outstanding service to our customers worldwide. Arivo's mission is to bring you an efficient driving and tyre experience for your everyday requirements.</dd>
        <dd>The Ultimate Driving Experience is to arrive at your destination with ARIVO's Safety, Quality and Performance.</dd>
        </dl>
        <dl id="dl_cn" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_es" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_ru" class="hide">
            <dd>test</dd>
        </dl>
    </div>
</template>
<script>
import $ from "jquery";
import Constants from "../../consts";
import VueCookies from "vue-cookies";
import consts from "../../consts";
export default {
  name: "AboutUs_Content",
  mounted: function() {
    $("#dl_en")
      .addClass("show")
      .removeClass("hide");
    //   let lang = VueCookies.get(consts.COOKIE_LANG);
    //   if(lang){
    //       $('#dl_' + lang).addClass('show').removeClass('hide')
    //   }else{
    //       $('#dl_en').addClass('show').removeClass('hide')
    //   }
  }
};
</script>
<style>
.hide {
  display: none;
}
.show {
  display: block;
}
</style>




// WEBPACK FOOTER //
// src/components/company/aboutus_content.vue